import React, { useState, useEffect, FC } from 'react';
import './stock-table-count-cell.scss';
import { Button } from 'primereact/button';
import { RadioButton } from "primereact/radiobutton";
import { useSelector } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
interface StockTableCountCellProps {
    stock: number;
    originalValue?: number;
    setStock: Function;
    transfer?: boolean;
    destinationShop?: string;
    setDestinationShop?: Function;
    handleStockModify?: Function;
    externalDestination?: string;
}
export enum StockDestination {
    Vitrine = 'Vitrine',
    OtherShop = 'Other Shop',
    Trash = 'Trash',
}
const StockTableCountCell:FC<StockTableCountCellProps> = ({stock, originalValue, setStock, destinationShop, setDestinationShop, transfer=true, handleStockModify, externalDestination}) => {
    const [count, setCount] = useState(stock);
    const [destination, setDestination] = useState(externalDestination??StockDestination.Vitrine);
    const [isUpdating, setIsUpdating] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const user = useSelector((state: any) => state.auth.user);
    const userShops = user.shops;
    const shopsOptions = userShops.map((shop: any) => ({ name: shop.name, value: shop.id }));
    const bulkLoading = useSelector((state: any) => state.product.bulk_loading);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
    const handleActionOnCount = (action: string) => {
        if (action === 'minus' && count === 0) return;
        if (action === 'minus') {
            setCount(count - 1);
            handleStockModify(count - 1, destinationShop, destination);
        } else {
            setCount(count + 1);
            handleStockModify(count + 1, destinationShop, destination);
        }
    }
    const handleCountChange = (value: number | null) => {
        if (value === null) return;
        if (value < 0) value = 0;
        setCount(value);
    }
    const showActionButtons = count !== originalValue;
    useEffect(() => {
        setIsUpdating(false);
    }, [showActionButtons]);
    useEffect(() => {
        if(!isMobile) {
            setCount(originalValue);
        }
    }, [originalValue, isMobile]);
    const showDestinationSelector = count < originalValue;
    const optionTemplate = (option: any) => {
        return <div className="stock-table-count-cell__dropdown__option">{option?.name || 'Select a shop'}</div>;
    }   
    const handleUpdateStock = async () => {
        setIsUpdating(true);
        await setStock(count, destinationShop, destination);
    };
    const handleDestinationChange = (value: string) => {
        setDestination(value as StockDestination);
        handleStockModify(count, destinationShop, value);
    }
    return (
        <div className="stock-table-count-cell">
            <div className="stock-table-count-cell__count-controls">
                <Button 
                    onClick={() => handleActionOnCount('minus')} 
                    icon="pi pi-minus" 
                    label={''} 
                    className="stock-table-count-cell__count-controls__button"
                    disabled={isUpdating || bulkLoading} 
                />
                {isEditing ? (
                    <InputNumber 
                        value={count}
                        onValueChange={(e) => handleCountChange(e.value)}
                        min={0}
                        className="stock-table-count-cell__count-controls__input"
                        onBlur={() => setIsEditing(false)}
                        autoFocus
                    />
                ) : (
                    <div 
                        className="stock-table-count-cell__count-controls__count"
                        onClick={() => !isUpdating && setIsEditing(true)}
                        style={{ cursor: isUpdating ? 'default' : 'pointer' }}
                    >
                        {count}
                        <i className="pi pi-pencil edit-icon"></i>
                    </div>
                )}
                <Button 
                    onClick={() => handleActionOnCount('plus')} 
                    icon="pi pi-plus" 
                    label={''} 
                    className="stock-table-count-cell__count-controls__button"
                    disabled={isUpdating || bulkLoading} 
                />
            </div>
            {
                showDestinationSelector && transfer &&
                <div className="stock-table-count-cell__destination-selector">
                    <div className="stock-table-count-cell__destination-selector__item">
                        <RadioButton inputId="vitrine" name="vitrine"  className="stock-table-count-cell__destination-selector__item__radio" value={StockDestination.Vitrine} onChange={(e) => handleDestinationChange(e.value)} checked={destination === StockDestination.Vitrine} />
                        <label htmlFor="vitrine" className="ml-1">Vitrine</label>    
                    </div>
                    <div className="stock-table-count-cell__destination-selector__item">
                        <RadioButton inputId="other-shop" name="other-shop" className="stock-table-count-cell__destination-selector__item__radio" value={StockDestination.OtherShop} onChange={(e) => handleDestinationChange(e.value)} checked={destination === StockDestination.OtherShop} />
                        <label htmlFor="other-shop" className="ml-1">Other shop</label>    
                    </div>
                    <div className="stock-table-count-cell__destination-selector__item">
                        <RadioButton inputId="trash" name="trash" className="stock-table-count-cell__destination-selector__item__radio" value={StockDestination.Trash} onChange={(e) => handleDestinationChange(e.value)} checked={destination === StockDestination.Trash} />
                        <label htmlFor="trash" className="ml-1">Trash</label>    
                    </div>
                </div>
            }
            {
                showDestinationSelector && destination === StockDestination.OtherShop &&
                <Dropdown value={destinationShop} onChange={(e) => {setDestinationShop(e.value);handleStockModify(count, e.value, destination)}} options={shopsOptions} optionLabel="name" placeholder="Select a shop" className='stock-table-count-cell__dropdown' itemTemplate={optionTemplate} valueTemplate={optionTemplate}/>
            }
            {showActionButtons && 
            <>
                <Button 
                    onClick={handleUpdateStock} 
                    label={isUpdating ? '' : 'Update stock'} 
                    icon={isUpdating ? 'pi pi-spinner pi-spin' : undefined}
                    className="stock-table-count-cell__update-button" 
                    disabled={isUpdating || bulkLoading}
                />
                <Button 
                    onClick={() => setCount(originalValue)} 
                    label={'Cancel'} 
                    className="stock-table-count-cell__cancel-button" 
                    disabled={isUpdating || bulkLoading}
                />
            </>
            }
        </div>
    );
}
         
export default StockTableCountCell;